// extracted by mini-css-extract-plugin
module.exports = {"custom-link-modal__spin":"_22oaRHMCCx4D285sDvrmGo"};